import { useState } from "react";
import { DraftPicksSheet } from "../../components/DraftPicksSheet.tsx";
import { helpers } from "../../util/helpers.ts";
import i18n from "../../util/i18n.ts";
import { useLocalPartial } from "../../util/local.ts";

// G2d-2 draft-domain IA merge: this replaces the retired DraftHubTabs 4-tab
// strip. Rather than four equal PC-style tabs, the Draft page (the single
// converged draft-domain entry) shows a phase status line plus links to the
// sibling draft views presented as the draft flow (scout → lottery → picks →
// recap). All sibling routes are preserved for deep-linking; the lottery /
// scouting pages carry a single "back to the draft" breadcrumb instead of the
// tab strip, so navigation converges here (法则二).
//
// M3-4: the "picks" stage is no longer a route link — the standalone draft-picks
// page was retired into the DraftPicksSheet MobileSheet, so that stage opens the
// sheet in place (own team) instead of navigating.
const STAGES: {
  key: string;
  href?: string[];
  sheet?: "draftPicks";
  label: string;
  defaultLabel: string;
}[] = [
  {
    key: "scouting",
    href: ["draft_scouting"],
    label: "draftHub.navScouting",
    defaultLabel: "Scout prospects",
  },
  {
    key: "lottery",
    href: ["draft_lottery"],
    label: "draftHub.navLottery",
    defaultLabel: "Lottery result",
  },
  {
    key: "picks",
    sheet: "draftPicks",
    label: "draftHub.navPicks",
    defaultLabel: "My draft picks",
  },
  {
    key: "review",
    href: ["draft_history"],
    label: "draftHub.navReview",
    defaultLabel: "Draft recap",
  },
];

export const DraftPhaseNav = ({ draftIsOver }: { draftIsOver: boolean }) => {
  const { userTid } = useLocalPartial(["userTid"]);
  const [picksSheetOpen, setPicksSheetOpen] = useState(false);

  return (
    <nav
      aria-label={i18n.t("menu.Draft", { ns: "ui", defaultValue: "Draft" })}
      className="draft-phase-nav mb-3"
      data-draft-domain-nav=""
      data-draft-phase={draftIsOver ? "over" : "active"}
    >
      <div className="small text-body-secondary" data-draft-phase-status="">
        {draftIsOver
          ? i18n.t("draftHub.statusOver", { ns: "ui", defaultValue: "The draft is complete." })
          : i18n.t("draftHub.statusInProgress", {
              ns: "ui",
              defaultValue: "The draft is underway.",
            })}
      </div>
      <div className="d-flex flex-wrap gap-2 mt-1" data-draft-domain-links="">
        {STAGES.map((stage) =>
          stage.sheet ? (
            <button
              className="btn btn-light-bordered btn-sm"
              data-draft-domain-link={stage.key}
              key={stage.key}
              onClick={() => setPicksSheetOpen(true)}
              type="button"
            >
              {i18n.t(stage.label, { ns: "ui", defaultValue: stage.defaultLabel })}
            </button>
          ) : (
            <a
              className="btn btn-light-bordered btn-sm"
              data-draft-domain-link={stage.key}
              href={helpers.leagueUrl(stage.href!)}
              key={stage.key}
            >
              {i18n.t(stage.label, { ns: "ui", defaultValue: stage.defaultLabel })}
            </a>
          ),
        )}
      </div>
      <DraftPicksSheet
        onClose={() => setPicksSheetOpen(false)}
        open={picksSheetOpen}
        tid={userTid}
      />
    </nav>
  );
};

export default DraftPhaseNav;
